import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { FilterQueryType } from "byzantine/src/dbbl/businessLogic/entities/paymentActivity";
import { StateType } from "../paymentActivityReducer";

const hasActiveFilters = (filters: FilterQueryType): boolean =>
  Object.entries(filters).some(([key, value]) => {
    if (Array.isArray(value)) return value.length > 0;
    if (key === "amount_gte" || key === "amount_lte")
      return value === 0 || value != null;
    return !!value;
  });

const EmptyState = ({
  state,
  handleReset,
}: {
  state: StateType;
  handleReset: () => void;
}) => {
  const { l10n } = useLocalization();
  const hasFilters = hasActiveFilters(state.filters);
  const hasSearch = state.searchValue.length > 0;

  let titleId = "";
  let subtitleId = "";

  if (hasFilters && hasSearch) {
    titleId = "payment-activity-search-empty";
    subtitleId = "payment-activity-empty-subtitle";
  } else if (hasFilters) {
    titleId = "payment-activity-filter-empty";
    subtitleId = "payment-activity-filter-empty-subtitle";
  } else if (hasSearch) {
    titleId = "payment-activity-search-empty";
    subtitleId = "payment-activity-search-empty-subtitle";
  } else {
    titleId = "payment-activity-empty-state";
  }

  return (
    <div className="margin--top--xl margin--bottom--l">
      {subtitleId ? (
        <>
          <span className="fontSize--l fontWeight--bold">
            {l10n.getString(titleId)}
          </span>
          <div>
            {l10n.getString(subtitleId)}
            {hasFilters && hasSearch && (
              <>
                {" "}
                <Button onClick={handleReset} kind="plain" testId="reset-payment-search-filters">
                  {l10n.getString("label-reset")}
                </Button>
                {"."}
              </>
            )}
          </div>
        </>
      ) : (
        l10n.getString(titleId)
      )}
    </div>
  );
};

export default EmptyState;
